
export default {
  name: 'BlogPagination',
  props: {
    storiesCount: {
      type: Number,
      default: 0
    },
    queryParams: {
      type: Object,
      required: true
    },
    limit: {
      type: Number,
      default: 5
    },
  },
  computed: {
    numPages () {
      const realLimit = this.limit > 0 ? this.limit : 100
      return Math.ceil(this.storiesCount / realLimit)
    }
  },
  methods: {
    target (i) {
      const hashes = []
      hashes.push('page=' + i)
      if (this.queryParams.alltags) {
        hashes.push('alltags')
      }
      if (this.queryParams.tag) {
        hashes.push('tag=' + this.queryParams.tag)
      }

      return `?${hashes.join('&')}`
    }
  }
}
